import api from "./api";

export const getProjectRoles = async () => {
  const res = await api.get("/meta/project-roles");
  return res.data;
};